<template>
  <div
    :class="{ message: true, success: type === 'success', fail: type === 'fail', disappear }"
    v-show="show"
    @transitionend="handleDisappeared"
  >
    <img :src="iconSrc" alt="icon" class="message__icon" />
    <span class="message__title">{{ title }}</span>
    <span class="message__content">{{ content }}</span>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
    title: String,
    content: String,
    show: Boolean,
  },
  data() {
    return {
      // 用于控制消失动画
      disappear: false,
    }
  },
  methods: {
    handleDisappeared() {
      this.$emit('update:show', false)
      this.disappear = false
    },
  },
  computed: {
    iconSrc() {
      return {
        success: require('@/assets/images/icon-success.svg'),
        fail: require('@/assets/images/icon-fail.svg'),
      }[this.type]
    },
  },
  watch: {
    show(val) {
      if (val) {
        setTimeout(() => (this.disappear = true), 4000)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.message {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 14px;
  width: 546px;
  height: 48px;
  position: fixed;
  top: 30px;
  left: calc(50% - 273px);
  line-height: 48px;
  border-radius: 3px;
  box-sizing: border-box;
  font-size: 14px;
  z-index: 1000;
  opacity: 1;
  transition: opacity 500ms;

  &__icon {
    width: 14px;
    height: 14px;
  }

  &__title {
    margin: 0 30px 0 10px;
  }

  &__content {
    color: #464646;
  }

  &.success {
    background-color: #e6f7ef;

    .message__title,
    .message__icon {
      color: #07b35d;
    }
  }

  &.fail {
    background-color: #f7e7e6;

    .message__title,
    .message__icon {
      color: #e84335;
    }
  }

  &.disappear {
    opacity: 0;
  }
}
</style>
